import { render } from "./SchedulingCustomization.vue?vue&type=template&id=c6224cfc"
import script from "./SchedulingCustomization.vue?vue&type=script&lang=js"
export * from "./SchedulingCustomization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__